import { Link } from 'react-router-dom';
import { buttonClass } from '@/components/ui/Button';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';
import { useI18n } from '@/hooks/useI18n';
import { AvisoDeTraduccion } from './AvisoDeTraduccion';
import type { LegalDocument } from './tipos';
import styles from './LegalDocumentPage.module.css';

interface LegalDocumentPageProps {
  document: LegalDocument;
  /** Description para la meta tag; si se omite se arma con el título. */
  metaDescription?: string;
}

/**
 * Renderiza cualquiera de los cinco documentos legales del sitio (los tres de
 * Ilumetria y los dos de Bar Bunny). Son páginas con URL propia, no modales:
 * tienen que poder citarse desde una ficha de Google Play o un contrato.
 */
export function LegalDocumentPage({ document, metaDescription }: LegalDocumentPageProps) {
  const { t } = useI18n();

  useDocumentMeta(
    `${document.title} — ILUMETRIA`,
    metaDescription ?? `${document.title}.`,
  );

  return (
    <div className={styles.page}>
      <div className="ilu-container">
        <article className={styles.doc}>
          <h1 className={styles.title}>{document.title}</h1>
          <p className={styles.effective}>{document.effectiveNote}</p>

          <AvisoDeTraduccion />

          {document.intro.length > 0 && (
            <div className={styles.intro}>
              {document.intro.map((paragraph, i) => (
                <p key={i}>{paragraph}</p>
              ))}
            </div>
          )}

          {document.sections.map((section, i) => (
            <section key={i} className={styles.section}>
              <h2>{section.title}</h2>
              {section.paragraphs.map((paragraph, j) => (
                <p key={j}>{paragraph}</p>
              ))}
            </section>
          ))}

          <Link to="/" className={[buttonClass({ variant: 'outline' }), styles.back].join(' ')}>
            {t.legal.volverAlInicio}
          </Link>
        </article>
      </div>
    </div>
  );
}
